<template>
  <c-collapse>
    <template v-slot:trigger="{ open }">
      <div
        class="flex items-center gap-1 text-sm font-medium text-secondary select-none"
      >
        <span>{{ $t("ask-referral-id") }}</span>
        <c-icon
          name="KeyboardArrowDownRound"
          size="20px"
          class="text-muted transition-transform duration-200"
          :class="{ 'rotate-180': open }"
        />
      </div>
    </template>
    <div class="pt-2.5">
      <n-input
        :placeholder="$t('referral-code')"
        :value="value"
        @update:value="(value) => $emit('update:value', value)"
      />
      <div class="mt-1.5 text-xs text-muted">
        {{ $t("referral-message") }}
      </div>
    </div>
  </c-collapse>
</template>

<script>
import CIcon from "../../../core-ui/src/components/CIcon.vue";
import CCollapse from "../../../core-ui/src/components/CCollapse.vue";

export default {
  name: "ReferralCodeField",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  emits: ["update:value"],
  components: {
    CIcon,
    CCollapse,
  },
};
</script>

<style scoped></style>
